export default "__VITE_ASSET__B2QqIXFI__"